module.exports = __webpack_public_path__ + "img/email_header_img.9fac8115.png";